import React from 'react';
import Checkmark from 'components/common/icons/checkmark';

export default props => (
  <Checkmark className="mergeProfileModal-profileCard-checkmark" height="16px" width="16px" {...props} />
);
